<template>
  <div class="full-size">
    <header>
      <div class="container">
        <h1 class="title">
          {{ $t("register.title") }}
          <span>{{ $t("register.titleSpan") }}</span>
        </h1>
        <p class="subtitle">{{ $t("register.refill") }}</p>
        <p class="subtitle">{{ $t("register.terms") }}</p>
      </div>
    </header>
    <div class="container">
      <div class="formContent">
        <div class="formElement">
          <label>{{ $t("register.name") }}</label>
          <input
            :placeholder="$t('register.name')"
            type="text"
            v-model="firstname"
          />
        </div>
        <div class="formElement">
          <label>{{ $t("register.password") }}</label>
          <input
            :placeholder="$t('register.password')"
            type="password"
            v-model="password"
          />
        </div>
        <div class="formElement">
          <label>{{ $t("register.lastname") }}</label>
          <input
            :placeholder="$t('register.lastname')"
            type="text"
            v-model="lastname"
          />
        </div>
        <div class="formElement">
          <label>{{ $t("register.repeatpassword") }}</label>
          <input
            :placeholder="$t('register.repeatpassword')"
            type="password"
            v-model="repeatPassword"
          />
        </div>
        <div class="formElement">
          <label>{{ $t("register.email") }}</label>
          <input
            :placeholder="$t('register.email')"
            type="text"
            v-model="email"
          />
        </div>

        <div class="formElement terms">
          <label class="container">
            <input type="checkbox" checked="checked" v-model="tos" />
            <span class="checkmark"></span>
          </label>
          <a
            :href="tosLink"
            target="_blank"
            style="
              text-decoration: underline;
              color: #9c9b9b;
              font-size: 0.8em;
              margin: -20px;
            "
            >{{ $t("register.acceptTos") }}</a
          >
        </div>
      </div>
      <div class="clear">
        <p class="error" v-if="error">{{ $t(errorMessage) }}</p>

        <button
          v-bind:class="{ buttonDisabled: !isFormValid }"
          v-on:click="register"
          v-bind:disabled="!isFormValid"
        >
          {{ $t("register.create") }}
        </button>

        <p class="noRegister">
          <router-link to="/login">{{ $t("register.return") }}</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import { EventBus } from "../../util/event-bus";
import constants from "@/config/constants";
import i18n from "@/config/i18n";

export default {
  name: "register",
  data: function () {
    return {
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      repeatPassword: "",
      error: false,
      errorMessage: "",
      tos: false,
    };
  },

  computed: {
    isFormValid: function () {
      return (
        this.firstname.length > 0 &&
        this.lastname.length > 0 &&
        this.email.length > 0 &&
        this.password.length > 0 &&
        this.repeatPassword.length > 0 &&
        this.password === this.repeatPassword &&
        this.checkEmail(this.email) &&
        this.tos
      );
    },

    tosLink: function () {
      let url = constants.tos.all;
      if (!url) url = constants.tos.en;
      return url;
    },
  },

  methods: {
    checkEmail: function (email) {
      // eslint-disable-next-line
      let re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    register: function () {
      EventBus.$emit("showLoading");

      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(() => {
          firebase
            .auth()
            .signInWithEmailAndPassword(this.email, this.password)
            .then((user) => {
              firebase
                .database()
                .ref("users/" + user.user.uid)
                .set({
                  firstname: this.firstname,
                  lastname: this.lastname,
                  email: this.email,
                  mode: "standard",
                  provider: "password",
                  uid: user.user.uid,
                  tos: Date.now(),
                  fbversion: constants.currentVersion,
                })
                .then(() => {
                  this.$store.dispatch("init", user.user).then(() => {
                    this.$router.push("/installations");
                  });
                })
                .catch((error) => {
                  console.log(error);
                });
            });
        })
        .catch((error) => {
          this.error = true;
          this.errorMessage = error.code;
        })
        .then(() => {
          EventBus.$emit("hideLoading");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  .buttonDisabled {
    opacity: 0.5;
  }

  .full-size {
    width: 100%;

    header {
      background: url("/home/images/backgrounds/register.jpg") center center;
      .container {
        padding: 12vh 2vw;
      }
    }

    .container {
      margin: 0 auto;
      padding: 2vw;
      width: 768px;
      max-width: 100%;

      .title {
        font-size: 2.2em;
        text-align: left;
        color: white;
        font-weight: normal;
        margin-bottom: 0.8rem;

        span {
          font-weight: bold;
        }
      }
      .subtitle {
        font-size: 0.8em;
        text-align: left;
        color: white;
        margin-top: 0;
        margin-bottom: 0.8rem;
      }

      .formContent {
        text-align: left;
        margin-bottom: 1.5rem;

        .formElement {
          margin: 1rem 1rem;
          width: calc(50% - 1rem);
          float: left;

          label,
          .recoverPassword a {
            color: #9c9b9b;
            font-size: 0.8rem;
            transition: 0.2s ease-in-out color;
            vertical-align: text-bottom;
          }
          input[type="text"],
          [type="password"] {
            padding: 8px;
            display: block;
            border: none;
            border-bottom: 1px solid #9c9b9b;
            width: 100%;
            transition: 0.2s ease-in-out border;
          }
          input[type="checkbox"] {
            margin-right: 10px;
          }
          input:focus {
            border-bottom: 1px solid #2dab66;
          }
          .recoverPassword {
            float: right;
          }
          .recoverPassword a:hover {
            color: #2dab66;
          }
        }
        .formElement:nth-child(odd) {
          margin-left: 0;
        }
        .formElement:nth-child(even) {
          margin-right: 0;
        }
        .formElement.terms {
          padding-top: 2rem;

          label {
            text-decoration: underline;
            padding-left: 30px;
          }
          /* Ocultar checkbox por defecto */
          input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
          }

          /* Crear checkbox personalizado */
          .checkmark {
            position: absolute;
            top: 2vw;
            left: 0;
            height: 23px;
            width: 23px;
            background-color: #eee;
            border-radius: 50%;
            border: 2px solid #eee;
            transition: 0.2s ease-in-out all;
          }
          .container:hover input ~ .checkmark {
            background-color: #ccc;
          }
          .container:hover input:checked ~ .checkmark {
            background-color: #ccc;
          }
          .container input:checked ~ .checkmark {
            background-color: #ffffff;
            border: 2px solid #00b900;
          }
          .checkmark:after {
            content: "";
            position: absolute;
            display: none;
          }
          .container input:checked ~ .checkmark:after {
            display: block;
          }
          .container .checkmark:after {
            left: 7px;
            top: 3px;
            width: 6px;
            height: 12px;
            border: solid #00b900;
            border-width: 0 2px 2px 0;
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
          }
        }

        .error {
          font-size: 0.8rem;
          color: #a12d2d;
          margin-bottom: 2em;
        }
      }

      button {
        background: #2dab66;
        /*padding: 5px 15px;*/
        padding: 4px 15px 6px;
        border-radius: 1vh;
        border: none;
        color: #ffffff;
        font-size: 1.3rem;
        cursor: pointer;
        transition: 0.2s ease-in-out background;
      }
      button:hover {
        background: #2fbd6f;
      }

      .noRegister {
        color: #eaeaea;
        margin-top: 10px;
        font-size: 0.8rem;

        a {
          color: #aaaaaa;
          transition: 0.2s ease-in-out color;
        }
        a:hover {
          color: #bbbbbb;
        }
      }
    }
    .clear {
      clear: both;
      margin-top: 20rem;
    }
  }
}

@include respondTo(mobile) {
  #app .full-size header .container {
    padding: 12vh 1rem;
  }
  #app .full-size .container .formContent {
    .formElement {
      width: 100%;
      padding: 1rem;
      margin: 0;
    }
    .formElement.terms {
      padding: 0;
      margin: 1rem;
      .container {
        padding-left: 2rem;
        /*.checkmark {
                      top: 5px;
                    }*/
      }
    }
  }
}

@include respondTo(tablet) {
}
</style>
